import React from 'react';
import { Control, UseFormSetValue } from 'react-hook-form';
import { Grid } from '@mui/material';
import { PersonOutlined } from '@mui/icons-material';
import { DiscountTypes, ShopTypes } from 'api';
import BRANDS from 'constants/brands';
import COUNTRIES from 'constants/countries';
import { FormCard, FormInput, ShopInput } from 'components';

interface Props {
  id: string | undefined;
  control: Control<DiscountTypes.ItemCreateParams> | undefined;
  setValue: UseFormSetValue<DiscountTypes.ItemCreateParams>;
  setSelectedShop: (id: ShopTypes.ItemData | undefined) => void;
}

const GeneralSettings = (props: Props): JSX.Element | null => {
  const { control, setValue, id, setSelectedShop } = props;

  return (
    <FormCard title="General information" avatar={<PersonOutlined />}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <ShopInput
            disabled={!!id}
            control={control}
            onChange={(shop) => {
              setValue('brand', shop.brand);
              setValue('country_team', shop.country_team);
              setSelectedShop(shop);
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <FormInput
            control={control}
            name="brand"
            inputType="select"
            label="Brand"
            options={BRANDS.OPTIONS}
            rules={{
              required: true,
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <FormInput
            control={control}
            name="country_team"
            inputType="select"
            label="Country team"
            options={COUNTRIES.OPTIONS}
            disabled
            rules={{
              required: true,
            }}
          />
        </Grid>
      </Grid>
    </FormCard>
  );
};

export default GeneralSettings;
